import React, { useContext, useEffect, useRef, useState } from 'react';
import { Grid, Typography, Box, Button, Tabs, Tab, FormControl, InputLabel, MenuItem, Paper, IconButton, Select, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import { AuthUser } from '../../../interfaces/Contexts';
import { getMentorshipDetails } from '../../../Utils/apiService';
import routes from '../../../Utils/routes';
import PeopleIcon from '@mui/icons-material/People';
import MentorshipContainer from '../../Mentorship/Mentorship';
import AppSearchBar from '../../../Components/AppSearchBar';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import MentorshipMobileview from '../../Mentorship/Mentorship/MentorshipMobileview';
import { useStyles } from '../../Mentorship/style';
import KenDialog from '../../../GlobalComponents/KenDialog';
import FormField from '../../Mentorship/formField';
import { MentorshipPreferenceModal } from '../../Settings/components/MentorShip';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface ContactDetails {
  city?: string;
  batch?: string;
  company?: string;
  postCompany?: string;
  industry?: string;
  name?: string;
  designation?: string;
  createdDate?: string;
  [key: string]: any;
}

interface MentorMenteeItem {
  contactDetails: ContactDetails;
  isMentor?: boolean;
  isMentee?: boolean;
  mentorConnectionRequestSent?: boolean;
  mentorConnectionRequestRejected?: boolean;
  [key: string]: any;
}

const FILTER_MODAL_WIDTH = 350; // px

const MentorshipContent: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const {
    state: { user }
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();

  // Data states
  const [mentors, setMentors] = useState<any>([]);
  const [mentees, setMentees] = useState<any>([]);
  const [allMentors, setAllMentors] = useState<any>([]);
  const [allMentees, setAllMentees] = useState<any>([]);

  // Search and filter states
  const [localSearchInput, setLocalSearchInput] = useState('');
  const [searchInput, setSearchInput] = useState<string>('');
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [Sortby, setSortby] = useState('');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState<any>({
    locations: [],
    graduationYear: '',
    currentCompany: '',
    postCompany: '',
    industry: '',
  });

  // Separate states for each tab
  const [mentorSearchInput, setMentorSearchInput] = useState('');
  const [menteeSearchInput, setMenteeSearchInput] = useState('');
  const [mentorSortBy, setMentorSortBy] = useState('');
  const [menteeSortBy, setMenteeSortBy] = useState('');
  const [mentorFilterOpen, setMentorFilterOpen] = useState(false);
  const [menteeFilterOpen, setMenteeFilterOpen] = useState(false);
  const [mentorSelectedValues, setMentorSelectedValues] = useState<any>({
    locations: [],
    graduationYear: '',
    currentCompany: '',
    postCompany: '',
    industry: '',
  });
  const [menteeSelectedValues, setMenteeSelectedValues] = useState<any>({
    locations: [],
    graduationYear: '',
    currentCompany: '',
    postCompany: '',
    industry: '',
  });

  const [isPreferenceModalOpen, setIsPreferenceModalOpen] = useState(false);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    // Close filter modal when switching tabs
    setMentorFilterOpen(false);
    setMenteeFilterOpen(false);
  };

  // Fetch mentorship details
  useEffect(() => {
    setLoading(true);
    getMentorshipDetails(userData?.applicantId)
      .then((res) => {
        const data = res?.data?.data;
        const allMentorsData = data?.MentorDetails || [];
        const allMenteesData = data?.MenteeDetails || [];

        const yourMentors = allMentorsData.filter((item: {
          isMentor: boolean;
          mentorConnectionRequestSent?: boolean;
          mentorConnectionRequestRejected?: boolean;
        }) =>
          item.mentorConnectionRequestSent === true &&
          item.mentorConnectionRequestRejected !== true
        );

        const yourMentees = allMenteesData.filter((item: {
          isMentee: boolean;
        }) => item.isMentee === true);

        setAllMentors(yourMentors);
        setAllMentees(yourMentees);
        setMentors(yourMentors);
        setMentees(yourMentees);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [userData?.applicantId]);

  // Search and filter handlers
  let recognition: any | null = null;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLocalSearchInput(event.target.value);
    setSearchInput(event.target.value);
    filterJobs(value === 0 ? allMentors : allMentees, selectedValues, event.target.value);
  };

  const handleMicHold = () => {
    setNotificationOpen(true);
    if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
      recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
      recognition.lang = 'en-US';
      recognition.onstart = () => {
        console.log('Speech recognition started');
      };
      recognition.onresult = (event: SpeechRecognitionEvent) => {
        const speechResult = event.results[0][0].transcript;
        setLocalSearchInput(speechResult);
        setSearchInput(speechResult);
        filterJobs(value === 0 ? allMentors : allMentees, selectedValues, speechResult);
      };
      recognition.onend = () => {
        setNotificationOpen(false);
      };
      recognition.start();
    }
  };

  const handleMicRelease = () => {
    if (recognition) {
      recognition.stop();
    }
  };

  const handleChanges = (event: any) => {
    const sortOption = event.target.value;
    setSortby(sortOption);

    if (sortOption === "") {
      if (value === 0) {
        setMentors(allMentors);
      } else {
        setMentees(allMentees);
      }
      return;
    }

    const sortData = (data: any[]) => {
      return [...data].sort((a: any, b: any) => {
        const nameA = (a.contactDetails?.name || '').toLowerCase();
        const nameB = (b.contactDetails?.name || '').toLowerCase();

        if (sortOption === "A - Z") {
          return nameA.localeCompare(nameB);
        } else if (sortOption === "Z - A") {
          return nameB.localeCompare(nameA);
        } else if (sortOption === "Recently joined") {
          const dateA = new Date(a.contactDetails?.createdDate || 0).getTime();
          const dateB = new Date(b.contactDetails?.createdDate || 0).getTime();
          return dateB - dateA;
        }
        return 0;
      });
    };

    if (value === 0) {
      setMentors(sortData(mentors));
    } else {
      setMentees(sortData(mentees));
    }
  };

  const filterJobs = (jobs: any[], criteria: any, searchInput: string) => {
    // Map filter keys to correct mentor data structure
    const getNestedFieldValue = (job: any, key: string): any => {
      const pathMap: Record<string, string> = {
        locations: 'contactDetails.city',
        graduationYear: 'contactDetails.batch',
        currentCompany: 'contactDetails.company',
        postCompany: 'contactDetails.postCompany',
        industry: 'contactDetails.industry',
        // fallback for search fields
        City__c: 'contactDetails.city',
        Year_of_Graduation__c: 'contactDetails.batch',
        Industry__c: 'contactDetails.industry',
        Current_Company__c: 'contactDetails.company',
        Post_Company__c: 'contactDetails.postCompany',
      };
      const path = pathMap[key] || key;
      return path.split('.').reduce((obj, part) => obj?.[part], job);
    };

    const filteredJobs = jobs.filter((job: any) => {
      // Filtering by criteria
      const matchesCriteria = Object.keys(criteria).every((key) => {
        const selectedValues = criteria[key];
        if (!selectedValues || selectedValues.length === 0) return true;
        const jobValue = getNestedFieldValue(job, key);
        if (Array.isArray(selectedValues)) {
          return selectedValues.includes(jobValue);
        }
        return jobValue === selectedValues;
      });

      // Search fields
      const searchFields = [
        'contactDetails.company',
        'contactDetails.designation',
        'contactDetails.industry',
        'contactDetails.interests',
        'contactDetails.name',
        'contactDetails.occupation',
        'contactDetails.postCompany',
        'contactDetails.program',
        'contactDetails.street',
        'contactDetails.batch',
      ];
      const matchesSearch = searchFields.some((field) => {
        const jobFieldValue = field.split('.').reduce((obj, part) => obj?.[part], job);
        return jobFieldValue?.toString().toLowerCase().includes(searchInput.toLowerCase());
      });

      return matchesCriteria && (searchInput ? matchesSearch : true);
    });

    if (value === 0) {
      setMentors(filteredJobs);
    } else {
      setMentees(filteredJobs);
    }
  };

  const toggleFilter = () => {
    setIsFilterOpen(true);
  };

  const closeFilter = () => {
    setIsFilterOpen(false);
  };

  const handleFilterChange = (filterName: string, filterValue: any) => {
    if (value === 0) {  // Check current tab value
      setMentorSelectedValues((prevValues: any) => ({
        ...prevValues,
        [filterName]: filterValue,
      }));
    } else {
      setMenteeSelectedValues((prevValues: any) => ({
        ...prevValues,
        [filterName]: filterValue,
      }));
    }
  };

  const applyFilters = () => {
    const currentData = value === 0 ? allMentors : allMentees;
    const currentSelectedValues = value === 0 ? mentorSelectedValues : menteeSelectedValues;
    const currentSearchInput = value === 0 ? mentorSearchInput : menteeSearchInput;

    const filteredData = currentData.filter((user: any) => {
      const { locations, graduationYear, currentCompany, postCompany, industry } = currentSelectedValues;
      const location = user?.contactDetails?.city;
      const year = user?.contactDetails?.batch;
      const company = user?.contactDetails?.company;
      const post = user?.contactDetails?.postCompany;
      const ind = user?.contactDetails?.industry;

      const locationMatches = locations.length ? locations.includes(location) : true;
      const yearMatches = graduationYear ? year === graduationYear : true;
      const companyMatches = currentCompany ? company === currentCompany : true;
      const postMatches = postCompany ? post === postCompany : true;
      const industryMatches = industry ? ind === industry : true;

      // Search functionality
      const searchFields = [
        user?.contactDetails?.company,
        user?.contactDetails?.designation,
        user?.contactDetails?.industry,
        user?.contactDetails?.interests,
        user?.contactDetails?.name,
        user?.contactDetails?.occupation,
        user?.contactDetails?.postCompany,
        user?.contactDetails?.program,
        user?.contactDetails?.street,
        user?.contactDetails?.batch,
      ];

      const matchesSearch = currentSearchInput
        ? searchFields.some(field =>
          field?.toString().toLowerCase().includes(currentSearchInput.toLowerCase())
        )
        : true;

      return locationMatches && yearMatches && companyMatches && postMatches && industryMatches && matchesSearch;
    });

    if (value === 0) {
      setMentors(filteredData);
    } else {
      setMentees(filteredData);
    }

    // Close all filter modals
    setMentorFilterOpen(false);
    setMenteeFilterOpen(false);
    setIsFilterOpen(false);
  };

  const clearFilters = () => {
    const emptyValues = {
      locations: [],
      graduationYear: '',
      currentCompany: '',
      postCompany: '',
      industry: '',
    };

    if (value === 0) {
      setMentorSelectedValues(emptyValues);
      setMentors(allMentors);
    } else {
      setMenteeSelectedValues(emptyValues);
      setMentees(allMentees);
    }
  };

  const getUniqueOptions = (field: string): string[] => {
    const fieldMap: Record<string, string> = {
      Year_of_Graduation__c: 'contactDetails.batch',
      Current_Company__c: 'contactDetails.company',
      Post_Company__c: 'contactDetails.postCompany',
      Industry__c: 'contactDetails.industry',
    };
    const mappedField = fieldMap[field] || field;
    const data = value === 0 ? allMentors : allMentees;
    return Array.from(new Set(data.map((item: MentorMenteeItem) => {
      const value = mappedField.split('.').reduce((obj, part) => obj?.[part], item);
      return typeof value === 'string' ? value : '';
    }))).filter(Boolean) as string[];
  };

  const handleSetupPreference = () => {
    setIsPreferenceModalOpen(true);
  };

  const renderEmptyState = (type: 'mentors' | 'mentees') => (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      py: 4,
      textAlign: 'center'
    }}>
      <PeopleIcon sx={{ fontSize: 60, color: '#ccc', mb: 2 }} />
      <Typography variant="body1" sx={{ mb: 2, color: '#666' }}>
        {type === 'mentors'
          ? "You don't have any mentors yet"
          : "You don't have any mentees yet"
        }
      </Typography>
      <Button
        variant="contained"
        onClick={handleSetupPreference}
        sx={{
          borderRadius: '6px',
          textTransform: 'none',
          fontSize: '12px',
          fontWeight: 500
        }}
      >
        Setup Mentorship Preferences
      </Button>
    </Box>
  );

  // Separate handlers for each tab
  const handleMentorSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMentorSearchInput(event.target.value);
    filterJobs(allMentors, mentorSelectedValues, event.target.value);
  };

  const handleMenteeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMenteeSearchInput(event.target.value);
    filterJobs(allMentees, menteeSelectedValues, event.target.value);
  };

  const handleMentorSort = (event: any) => {
    const sortOption = event.target.value;
    setMentorSortBy(sortOption);
    sortData(mentors, sortOption, setMentors);
  };

  const handleMenteeSort = (event: any) => {
    const sortOption = event.target.value;
    setMenteeSortBy(sortOption);
    sortData(mentees, sortOption, setMentees);
  };

  // Mentorship
  const filterButtonRef = useRef<HTMLButtonElement>(null);
  const [filterPosition, setFilterPosition] = useState({ top: 0, left: 0 });

  // Add this function to calculate position
  const calculateFilterPosition = () => {
    if (filterButtonRef.current) {
      const rect = filterButtonRef.current.getBoundingClientRect();
      setFilterPosition({
        top: rect.bottom + window.scrollY + 8, // 8px gap below button
        left: isMobile
          ? rect.left + rect.width / 2 + window.scrollX // center for mobile
          : rect.right - FILTER_MODAL_WIDTH + window.scrollX // align right edge for desktop
      });
    }
  };

  // Update the filter button click handler
  const handleFilterClick = () => {
    calculateFilterPosition();
    if (value === 0) {
      setMentorFilterOpen(true);
    } else {
      setMenteeFilterOpen(true);
    }
  };

  const sortData = (data: any[], sortOption: string, setData: React.Dispatch<React.SetStateAction<any[]>>) => {
    if (sortOption === "") {
      setData(value === 0 ? allMentors : allMentees);
      return;
    }

    const sortedData = [...data].sort((a: any, b: any) => {
      const nameA = (a.contactDetails?.name || '').toLowerCase();
      const nameB = (b.contactDetails?.name || '').toLowerCase();

      if (sortOption === "A - Z") {
        return nameA.localeCompare(nameB);
      } else if (sortOption === "Z - A") {
        return nameB.localeCompare(nameA);
      } else if (sortOption === "Recently joined") {
        const dateA = new Date(a.contactDetails?.createdDate || 0).getTime();
        const dateB = new Date(b.contactDetails?.createdDate || 0).getTime();
        return dateB - dateA;
      }
      return 0;
    });

    setData(sortedData);
  };

  const renderControls = (
    searchInput: string,
    setSearchInput: React.Dispatch<React.SetStateAction<string>>,
    sortBy: string,
    handleSort: (event: any) => void,
    isFilterOpen: boolean,
    setIsFilterOpen: React.Dispatch<React.SetStateAction<boolean>>,
    selectedValues: any,
    setSelectedValues: React.Dispatch<React.SetStateAction<any>>,
    data: any[]
  ) => (
    <Grid style={{ marginBottom: 10 }} container display="flex" alignItems="center" justifyContent="space-between">
      <Grid item md={4} lg={4} xl={4} xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography
          sx={{
            fontSize: '15px',
            color: '#373A45',
            fontWeight: '500',
            textAlign: 'start',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              fontSize: '12px !important',
            },
            '@media (min-width: 1920px) and (max-width: 1940px)': {
              fontSize: '20px !important',
            },
          }}
        >
          {value === 0 ? 'Your mentors' : 'Your mentees'}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={3} md={3} lg={3} xl={3} sx={{ display: { xs: 'none', sm: 'block' } }}>
        <AppSearchBar
          handleMicHold={handleMicHold}
          handleMicRelease={handleMicRelease}
          localSearchInput={searchInput}
          handleChange={(e) => {
            setSearchInput(e.target.value);
            filterJobs(value === 0 ? allMentors : allMentees, selectedValues, e.target.value);
          }}
          openSnackbar={notificationOpen}
        />
      </Grid>
      <Grid item md={1.5} lg={1.5} xl={1.5} style={{ float: "right" }} sx={{ display: { xs: 'none', sm: 'block' } }}>
        <FormControl style={{ width: '90%', float: "right", paddingRight: "10%", fontSize: "12px" }} size="small">
          <InputLabel id="demo-simple-select-label">Sort by</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={sortBy}
            label="Sort by"
            onChange={handleSort}
          >
            <MenuItem value="">Clear</MenuItem>
            <MenuItem value={"A - Z"}>A - Z</MenuItem>
            <MenuItem value={"Z - A"}>Z - A</MenuItem>
            <MenuItem value={"Recently joined"}>Recently joined</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={1} md={1} lg={1} xl={1} sx={{ display: { xs: 'none', sm: 'block' } }}>
        <Button
          ref={filterButtonRef}
          style={{ color: "#373A45", backgroundColor: "#E8EBF3", borderRadius: 8, float: "right", width: "100%" }}
          startIcon={<FilterAltOutlinedIcon style={{ color: "#373A45" }} />}
          onClick={handleFilterClick} // Change this from () => setIsFilterOpen(true)
        >
          Filter
        </Button>
      </Grid>
      <Grid item md={1.8} lg={1.8} xl={1.8} sx={{ display: { xs: 'none', sm: 'block' } }}>
        <Button
          sx={{
            color: "#5b4200",
            backgroundColor: "#F7A703",
            borderRadius: 2,
            float: "right",
            fontWeight: "500",
            width: "95%",
            height: "40px",
            fontSize: 12,
            '@media (min-width: 1240px) and (max-width: 1280px)': {
              fontSize: 10,
            },
            '&:hover': {
              backgroundColor: "#F7A703",
              color: "#5b4200",
            },
          }}
          onClick={handleSetupPreference}
        >
          Edit preferences
        </Button>
      </Grid>

      {isMobile && (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <AppSearchBar
              handleMicHold={handleMicHold}
              handleMicRelease={handleMicRelease}
              localSearchInput={searchInput}
              handleChange={(e) => {
                setSearchInput(e.target.value);
                filterJobs(value === 0 ? allMentors : allMentees, selectedValues, e.target.value);
              }}
              openSnackbar={notificationOpen}
            />
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth size="small">
              <InputLabel>Sort by</InputLabel>
              <Select
                value={sortBy}
                label="Sort by"
                onChange={handleSort}
                sx={{ height: '40px', borderRadius: "8px" }} // Fixed height
              >
                <MenuItem value="">Clear</MenuItem>
                <MenuItem value={"A - Z"}>A - Z</MenuItem>
                <MenuItem value={"Z - A"}>Z - A</MenuItem>
                <MenuItem value={"Recently joined"}>Recently joined</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <Button
              ref={filterButtonRef} // Add this ref
              fullWidth
              style={{
                color: "#373A45",
                backgroundColor: "#E8EBF3",
                borderRadius: 8,
                height: '40px'
              }}
              startIcon={<FilterAltOutlinedIcon style={{ color: "#373A45" }} />}
              onClick={handleFilterClick} // Use the new handler instead of () => setIsFilterOpen(true)
            >
              Filter
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              fullWidth
              sx={{
                color: "#5b4200",
                backgroundColor: "#F7A703",
                borderRadius: 2,
                fontWeight: "500",
                fontSize: 12,
                height: '40px', // Fixed height to match other buttons
                '&:hover': {
                  backgroundColor: "#F7A703",
                  color: "#5b4200",
                },
              }}
              onClick={handleSetupPreference}
            >
              Edit preferences
            </Button>
          </Grid>
        </Grid>
      )}

      {(isFilterOpen || mentorFilterOpen || menteeFilterOpen) && (
        <Paper
          className={`filter-modal ${classes.cardContainer2}`}
          sx={{
            position: "absolute",
            top: `${filterPosition.top}px`,
            left: isMobile ? "50%" : `${filterPosition.left}px`,
            transform: isMobile ? "translateX(-50%)" : "none",
            backgroundColor: "white",
            width: { xs: "90%", sm: `${FILTER_MODAL_WIDTH}px` },
            minWidth: { xs: "auto", sm: `${FILTER_MODAL_WIDTH}px` },
            maxWidth: { xs: "none", sm: `${FILTER_MODAL_WIDTH}px` },
            zIndex: 1000,
            border: "1px solid #bbbbbf",
            display: 'flex',
            flexDirection: 'column',
            maxHeight: { xs: "45vh", sm: "55vh" },
            height: { xs: "45vh", sm: "55vh" },
            p: 0,
          }}
        >
          {/* Header with close icon at right */}
          <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ p: 2, pb: 0 }}>
            <Typography style={{ fontWeight: "500" }}>Filter</Typography>
            <IconButton onClick={() => {
              setIsFilterOpen(false);
              setMentorFilterOpen(false);
              setMenteeFilterOpen(false);
            }}>
              <CloseIcon />
            </IconButton>
          </Box>
          {/* Scrollable filter fields */}
          <Box textAlign={"left"} sx={{ p: 2, pt: 0, flex: 1, overflowY: 'auto' }}>
            <InputLabel id="location-label" style={{ fontSize: 14, marginTop: 6 }}>Location</InputLabel>
            <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
              <Select
                labelId="location-label"
                multiple
                value={value === 0 ? mentorSelectedValues.locations : menteeSelectedValues.locations}
                onChange={(e) => handleFilterChange('locations', e.target.value)}
                renderValue={(selected) => (selected as string[]).join(', ')}
                sx={{ minHeight: '40px' }}
              >
                {((): JSX.Element[] => {
                  const cities: string[] = Array.from(new Set((value === 0 ? allMentors : allMentees)
                    .map((item: MentorMenteeItem) => item?.contactDetails?.city)
                    .filter((city: any): city is string => typeof city === 'string')));
                  return cities.map((city: string, index: number) => (
                    <MenuItem key={`${city}-${index}`} value={city}>
                      {city}
                    </MenuItem>
                  ));
                })()}
              </Select>
            </FormControl>

            <InputLabel id="year-label" style={{ fontSize: 14, marginTop: 6 }}>Year of Graduation</InputLabel>
            <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
              <Select
                labelId="year-label"
                value={value === 0 ? mentorSelectedValues.graduationYear : menteeSelectedValues.graduationYear}
                onChange={(e) => handleFilterChange('graduationYear', e.target.value)}
                sx={{ minHeight: '40px' }}
              >
                {getUniqueOptions('Year_of_Graduation__c').map((year: string) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <InputLabel id="company-label" style={{ fontSize: 14, marginTop: 6 }}>Current Company</InputLabel>
            <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
              <Select
                labelId="company-label"
                value={value === 0 ? mentorSelectedValues.currentCompany : menteeSelectedValues.currentCompany}
                onChange={(e) => handleFilterChange('currentCompany', e.target.value)}
                sx={{ minHeight: '40px' }}
              >
                {getUniqueOptions('Current_Company__c').map((company: string) => (
                  <MenuItem key={company} value={company}>
                    {company}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <InputLabel id="post-company-label" style={{ fontSize: 14, marginTop: 6 }}>Post Company</InputLabel>
            <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
              <Select
                labelId="post-company-label"
                value={value === 0 ? mentorSelectedValues.postCompany : menteeSelectedValues.postCompany}
                onChange={(e) => handleFilterChange('postCompany', e.target.value)}
                sx={{ minHeight: '40px' }}
              >
                {getUniqueOptions('Post_Company__c').map((postCompany: string) => (
                  <MenuItem key={postCompany} value={postCompany}>
                    {postCompany}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <InputLabel id="industry-label" style={{ fontSize: 14, marginTop: 6 }}>Industry</InputLabel>
            <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
              <Select
                labelId="industry-label"
                value={value === 0 ? mentorSelectedValues.industry : menteeSelectedValues.industry}
                onChange={(e) => handleFilterChange('industry', e.target.value)}
                sx={{ minHeight: '40px' }}
              >
                {getUniqueOptions('Industry__c').map((industry: string) => (
                  <MenuItem key={industry} value={industry}>
                    {industry}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          {/* Sticky button group at the bottom */}
          <Box display="flex" justifyContent="space-between" gap={2} sx={{ p: 2, pt: 0, borderRadius: "12px", background: 'white' }}>
            <Button
              onClick={clearFilters}
              sx={{ flex: 1, color: "#373a45" }}
            >
              Clear
            </Button>
            <Button
              onClick={applyFilters}
              color="primary"
              variant="contained"
              sx={{ flex: 1, color: "#5b4200" }}
            >
              Apply
            </Button>
          </Box>
        </Paper>
      )}
    </Grid>
  );

  return (
    <Box sx={{ p: 0 }}>
      <Grid container style={{ height: "74.3vh" }}>
        <Grid
          item
          lg={12}
          xl={12}
          sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: { xs: 2, sm: 0 },
          }}
        >
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tabs
              value={value}
              onChange={handleTabChange}
              aria-label="mentorship tabs"
              TabIndicatorProps={{
                style: {
                  backgroundColor: '#FAB400'
                },
              }}
              sx={{
                '& .MuiTab-root': {
                  textTransform: 'none',
                  fontSize: '14px',
                  fontWeight: 500,
                  minHeight: '48px',
                  '&.Mui-selected': {
                    color: '#373A45',
                  },
                  marginTop: "20px",
                }
              }}
            >
              <Tab label="Your mentors" {...a11yProps(0)} />
              <Tab label="Your mentees" {...a11yProps(1)} />
            </Tabs>
          </Box>

          <Box sx={{ minHeight: '400px' }}>
            <CustomTabPanel value={value} index={0}>
              {renderControls(
                mentorSearchInput,
                setMentorSearchInput,
                mentorSortBy,
                handleMentorSort,
                mentorFilterOpen,
                setMentorFilterOpen,
                mentorSelectedValues,
                setMentorSelectedValues,
                mentors
              )}
              {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <Typography>Loading...</Typography>
                </Box>
              ) : mentors.length > 0 ? (
                <Box
                  className="scrollbar-cusgray hihihih"
                  sx={{
                    maxHeight: '60vh',
                    overflowY: 'auto',
                    marginTop: { xs: 0, sm: '2rem' },
                  }}
                >
                  {isMobile ? (
                    <MentorshipMobileview cardData={mentors} title={''} />
                  ) : (
                    <MentorshipContainer cardData={mentors} title={''} type={'mentors'} hideTitle={true} />
                  )}
                </Box>
              ) : (
                renderEmptyState('mentors')
              )}
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
              {renderControls(
                menteeSearchInput,
                setMenteeSearchInput,
                menteeSortBy,
                handleMenteeSort,
                menteeFilterOpen,
                setMenteeFilterOpen,
                menteeSelectedValues,
                setMenteeSelectedValues,
                mentees
              )}
              {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <Typography>Loading...</Typography>
                </Box>
              ) : mentees.length > 0 ? (
                <Box
                  className="scrollbar-cusgray hihihih"
                  sx={{
                    maxHeight: '60vh',
                    overflowY: 'auto',
                    marginTop: { xs: 0, sm: '2rem' },
                  }}
                >
                  {isMobile ? (
                    <MentorshipMobileview cardData={mentees} title={''} />
                  ) : (
                    <MentorshipContainer cardData={mentees} title={''} type={'mentees'} hideTitle={true} />
                  )}
                </Box>
              ) : (
                renderEmptyState('mentees')
              )}
            </CustomTabPanel>
          </Box>
        </Grid>
      </Grid>
      {isPreferenceModalOpen && (
        <KenDialog
          open={isPreferenceModalOpen}
          handleClose={() => setIsPreferenceModalOpen(false)}
          title={
            <Box sx={{ paddingBottom: '10px' }}>
              <Box
                sx={{
                  borderBottom: '0.5px solid #0000004D',
                  paddingBottom: '20px',
                  marginLeft: '25px',
                }}
              >
                <Typography sx={{ fontSize: '16px', fontWeight: 500 }}>
                  Update your preferences
                </Typography>
              </Box>
            </Box>
          }
          maxWidth="lg"
          minWidth="900px"
          onClose={() => setIsPreferenceModalOpen(false)}
        >
          <MentorshipPreferenceModal onClose={() => setIsPreferenceModalOpen(false)} />
        </KenDialog>
      )}
    </Box>
  );
};

export default MentorshipContent;
